/**
 * API client for user annotation position endpoints.
 * Allows students to save their own custom positions for annotations.
 */

import axios from 'axios';
import { getAuthToken, getPortalType } from '@/utils/auth';
import { API_BASE_URL } from './config';

/**
 * Get authentication headers
 */
const getAuthHeaders = () => {
  const portal = getPortalType(window.location.pathname || '');
  const token = getAuthToken(portal);
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * User Annotation Positions API
 */
export const userAnnotationPositionsAPI = {
  /**
   * Get all annotation positions for a chapter for the current user
   * @param {number} chapterId - The chapter ID
   * @returns {Promise} Map of annotation_id -> {position_top, position_left}
   */
  getChapterPositions: async (chapterId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/users/chapters/${chapterId}/annotation-positions/`,
        { headers: getAuthHeaders() }
      );
      return response.data || {};
    } catch (error) {
      console.error('Error fetching annotation positions:', error);
      throw error;
    }
  },

  /**
   * Update annotation position for the current user
   * @param {number} annotationId - The annotation ID
   * @param {number} positionTop - Top position as percentage (0-100)
   * @param {number} positionLeft - Left position as percentage (0-100)
   * @returns {Promise} Updated position object
   */
  updatePosition: async (annotationId, positionTop, positionLeft) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/annotation-positions/`,
        {
          annotation_id: annotationId,
          position_top: positionTop,
          position_left: positionLeft
        },
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating annotation position:', error);
      throw error;
    }
  },
};

